import React, { useEffect, useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
  styled,
  alpha,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { API, graphqlOperation } from "aws-amplify";
import {
  deleteCompanyCodeTranslation,
  deleteItemCategorymaster,
} from "../../graphql/mutations";
import { LoadingButton } from "@mui/lab";
import { borderRadius } from "@mui/system";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../snackBar/snakbar";
import { SimpleTreeView, TreeItem, treeItemClasses } from "@mui/x-tree-view";
import { ArrowRight, Circle, Delete, Edit, Remove } from "@mui/icons-material";
import AddCategory from "./AddCategory";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { useThemes } from "../Theme/theme";
import { useCreateItemCategorymasterMutation } from "../../redux/apis/itemCategory.api";
import { useDispatch } from "react-redux";
import { dashboardApi } from "../../redux/apis/dashboardApi";

const style = {
  // minWidth:'200px',
  // height:'500px',
  overflow: "auto",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  "@media (min-width:600px)": {
    width: "auto",
  },
  width: "90%",
};

const CustomEndIcon = styled(Remove)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: "20px !important",
  // fontSize: '13px !important',                  // Customize size
}));
const CustomExpandIcon = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: "25px !important", // Customize size
}));
const CustomCollapseIcon = styled(ArrowDropDownIcon)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: "25px !important", // Customize size
}));
const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  [`& .${treeItemClasses.content}`]: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    height: "40px",
    // border: "1px solid #ffffff",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      left: -10,
      bottom: "50%",
      transform: "translateY(50%)",
      width: 10,
      // borderBottom: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginTop: -8,
    marginLeft: 13,
    paddingLeft: 8,
    // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    position: "relative",
  },
  [`& .${treeItemClasses.root}`]: {
    "&:last-child .${treeItemClasses.groupTransition}": {
      borderLeft: "none",
    },
  },
  [`& .singleChild .${treeItemClasses.groupTransition}`]: {
    "&:before": {
      content: '""',
      position: "absolute",
      left: -8,
      top: -12,
      height: 12,
      // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  },
  // [`& .${treeItemClasses.iconContainer} .MuiSvgIcon-root`]: {
  //     fontSize: "2rem",
  //     color: theme.palette.primary.main,
  // },

  // [`& .${treeItemClasses.iconContainer} > .MuiTreeItem-iconContainer .MuiSvgIcon-root`]:
  // {
  //     fontSize: "2rem !important",
  // },

  // [`& .${treeItemClasses.endIcon} .MuiSvgIcon-root`]: {
  //     width: 10,
  //     height: 10,
  // },
}));
const RecursiveListItem = ({ item, deleteCategory, rows, listCategory }) => {
  const { theme } = useThemes();
  const [editModal, setEditModal] = useState();
  const [editDetails, setEditDetails] = useState();
  return (
    <>
      <CustomTreeItem
        itemId={item?.value}
        label={
          <Box sx={{ width: "100%", display: "flex" }}>
            <Box
              sx={{
                width: "100%",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 2, // Limits to 2 lines
                lineHeight: "1.5", // Adjust based on typography line height
                maxHeight: "3em",
                fontSize: "14px",
              }}
            >
              {item.label}
            </Box>
            {item.parent !== null ? (
              <Box
                sx={{
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  sx={{
                    margin: "0px 2px",
                    padding: "5px",
                    backgroundColor: "#D0EFFF",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditModal(true);
                    let parentDetails = rows.find(
                      (e) => e.value == item.itemcategorygroupid
                    );
                    setEditDetails({ parent: parentDetails, child: item });
                  }}
                >
                  <Edit
                    sx={{
                      fontSize: "15px",
                      color: "#6096d9",
                    }}
                  />
                </IconButton>
                <IconButton
                  // disabled={item.parent == null}
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteCategory(item);
                    // deleteGroup(item)
                  }}
                  sx={{
                    margin: "0px 2px",
                    padding: "5px",
                    backgroundColor: "#fbc7c7",
                  }}
                >
                  <Delete
                    sx={{
                      fontSize: "15px",
                      color: "#eb6a6a",
                    }}
                  />
                </IconButton>
              </Box>
            ) : null}
          </Box>
        }
      >
        {item?.children.length !== 0 ? (
          <>
            {item?.children?.map((child) => {
              return (
                <RecursiveListItem
                  item={child}
                  deleteCategory={deleteCategory}
                  rows={rows}
                  listCategory={listCategory}
                />
              );
            })}
          </>
        ) : null}
      </CustomTreeItem>
      {editModal == true ? (
        <AddCategory
          open={editModal}
          setOpen={setEditModal}
          MainParent={editDetails?.child?.maincategory}
          editDetails={editDetails}
          listCategory={listCategory}
        />
      ) : null}
    </>
  );
};

const ViewPartyGroups = ({
  index,
  setrow,
  setState,
  open,
  setOpen,
  params,
  setCategoryArr,
  categoryArr,
  setCategoryModal,
  listCategory,
  FnAftrClose,
}) => {
  const { theme } = useThemes();
  const dispatch = useDispatch();

  const [loading, setloading] = useState(false);
  const [group, setGroup] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [rows, setRows] = useState([]);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  const handleConfirmClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setDeleteModal(false);
    }
  };
  const handleNewGroup = () => {
    handleClose();
    setCategoryModal(true);
  };
  let [expandIds, setExpandIds] = useState([]);

  function addParentKey(data) {
    const idToLabel = data.reduce((acc, item) => {
      acc[item.itemcategoryid] = item.label;
      return acc;
    }, {});

    data.forEach((item) => {
      item.parent = idToLabel[item.itemcategorygroupid] || null;
    });
    function countDescendants(node) {
      if (!node.children || node.children.length === 0) {
        return 0;
      }
      let count = node.children.length;
      node.children.forEach((child) => {
        count += countDescendants(child);
      });
      return count;
    }
    function sortTree(nodes) {
      nodes.forEach((node) => {
        node.descendantCount = countDescendants(node);
      });
      nodes.sort((a, b) => b.descendantCount - a.descendantCount);
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortTree(node.children);
        }
      });
    }
    const buildTree = (data) => {
      const tree = [];
      const childrenOf = {};
      data.forEach((item) => {
        item.children = childrenOf[item.itemcategoryid] =
          childrenOf[item.itemcategoryid] || [];
        const parentID = item.itemcategorygroupid;
        if (parentID && idToLabel[parentID]) {
          (childrenOf[parentID] = childrenOf[parentID] || []).push(item);
        } else {
          tree.push(item);
        }
      });
      sortTree(tree);
      return tree;
    };

    const flattenTree = (tree) => {
      let flat = [];
      tree.forEach((node) => {
        flat.push(node);
        if (node.children && node.children.length) {
          flat = flat.concat(flattenTree(node.children));
        }
      });
      return flat;
    };
    const tree = buildTree(data);
    let idS = flattenTree(tree)
      .filter((e) => e.children.length !== 0)
      .map((el) => el.value);
    // setExpandIds(flattenTree(tree).filter((e) =>
    //     e.children.length !== 0
    // ).map((el) => el.value))
    setExpandIds(idS.length == 0 ? [flattenTree(tree)[0].value] : idS);
    return buildTree(data);
  }

  useEffect(() => {
    categoryArr = categoryArr?.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }

      return 0;
    });
    setRows(addParentKey(categoryArr));
  }, [open, categoryArr]);
  const [
    createCategory,
    {
      isLoading: isCreatingCategory,
      isError: isCreateCategoryError,
      isSuccess: isCreateCategorySuccess,
      error: createCategoryError,
    },
  ] = useCreateItemCategorymasterMutation();
  const deleteMethod = async () => {
    try {
      setloading(true);
      // const res = await API.graphql(
      //     graphqlOperation(deleteItemCategorymaster, { ItemCategoryID: group?.ItemCategoryID })
      // )
      const data = {
        maincategory: group.maincategory,
        category: group.category,
        // CompanyID: 10001,
        // EnteredTimeStamp: Math.floor(new Date().getTime() / 1000),
        expiredtimestamp: Math.floor(Date.now() / 1000),
        itemcategorygroupid: group.itemcategorygroupid,
        itemcategoryid: group.itemcategoryid,
      };
      let res = {
        data: {
          deleteItemCategorymaster: (
            await createCategory({ createItemCategorymasterInput: { ...data } })
          ).data,
        },
      };
      console.log(res);
      if (res?.data?.deleteItemCategorymaster.statuscode === "Error") {
        setloading(false);
        setDeleteModal(false);
        setState((prev) => ({
          ...prev,
          itemCtegorey: group.itemcategoryid,
        }));
        showErrorSnackbar(res?.data?.deleteItemCategorymaster?.statusmessage);
      } else {
        if (res?.data?.deleteItemCategorymaster != null) {
          setOpen(false);
          setloading(false);
          setDeleteModal(false);
          dispatch(
            dashboardApi.util.invalidateTags(["Dashboard_itemCategoryMaster"])
          );
          showSuccessSnackbar("Category Deleted");
          listCategory();
        }
      }
    } catch (error) {
      console.log(error);
      setloading(false);
      setDeleteModal(false);
    }
  };
  const deleteGroup = (groupData) => {
    if (setrow !== undefined) {
      setrow((prevArray) => {
        let newArray = [...prevArray];
        let firstObject = { ...newArray[index] };
        firstObject.category = "";
        newArray[index] = firstObject;
        return newArray;
      });
    }
    if (setState !== undefined) {
      setState((prev) => ({
        ...prev,
        ["itemCtegorey"]: "",
      }));
    }
    setGroup(groupData);
    setDeleteModal(true);
  };
  return (
    <Modal
      id={open ? "deleteCategory" : ""}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
    >
      <Fade in={open}>
        <Paper
          style={{ boxShadow: "none" }}
          sx={{
            ...style,
            width: { xs: "90%", sm: "75%", md: "450px" },
          }}
        >
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
              position: "sticky",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                flex: 1,
                //  position: 'sticky',
                //  bottom: isItemModal === true ? 0 : '',
                //  paddingTop: isItemModal === true ? 4 : 0,
                //  paddingBottom: isItemModal === true ? 4 : 0,
                //  backgroundColor: isItemModal === true ? '#FFF' : '',
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Category List
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            className="custom-scrollbar"
            sx={{
              display: "flex",
              flexDirection: "column",
              // width: { sm: "75%", md: '450px' },
              height: "400px",
              padding: "15px",
              overflowX: "hidden",
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                justifyContent: "space-between",
                color: "#595C66",
                borderTopRightRadius: 4,
                borderTopLeftRadius: 4,
                p: 1,
                backgroundColor: "background.tablebg",
                display: "flex",
              }}
              gutterBottom
            >
              <Typography sx={{ fontWeight: "bold" }} align="left">
                Category
              </Typography>
              <Typography sx={{ fontWeight: "bold" }} align="left">
                Actions
              </Typography>
            </Typography>
            {expandIds.length !== 0 ? (
              <SimpleTreeView
                aria-label="customized"
                defaultExpandedItems={expandIds}
                slots={{
                  expandIcon: CustomExpandIcon,
                  collapseIcon: CustomCollapseIcon,
                  // endIcon: CustomEndIcon,
                }}
                sx={{
                  // overflowY: 'scroll', minHeight: 270,
                  flexGrow: 1,
                  width: "100%",
                }}
              >
                {rows?.map((item) => (
                  <RecursiveListItem
                    key={item.value}
                    item={item}
                    deleteCategory={deleteGroup}
                    rows={categoryArr}
                    listCategory={() => {
                      listCategory();
                      addParentKey(categoryArr);
                    }}
                  />
                ))}
              </SimpleTreeView>
            ) : null}
          </Box>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={deleteModal}
            onClose={handleConfirmClose}
            closeAfterTransition
          >
            <Paper sx={style}>
              <Box
                sx={{
                  borderRadius: "4px",
                  padding: "15px",
                  textAlign: "center",
                  overflowY: { xs: "scroll", sm: "hidden" },
                  ".MuiTableCell-root": {
                    padding: "6px 10px",
                    fontSize: "13px",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: theme?.palette?.TmId.id.toString().includes("9")
                      ? "white"
                      : "rgb(60 60 60)",
                    fontWeight: "bold",
                  }}
                >
                  Do you want to delete this Category?
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "rows",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  paddingBottom: "15px",
                }}
              >
                <Button
                  onClick={handleConfirmClose}
                  variant="outlined"
                  disabled={loading}
                  sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
                >
                  No
                </Button>
                <LoadingButton
                  loading={loading}
                  color="error"
                  disableRipple={true}
                  onClick={deleteMethod}
                  variant="contained"
                  sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
                >
                  Yes
                </LoadingButton>
              </Box>
            </Paper>
          </Modal>

          {/* <Box className="custom-scrollbar" sx={{
                        width: '450px',
                        height: '400px',
                        padding: "15px",
                        overflow: 'auto',

                        '.MuiTableCell-root': {
                            padding: '10px 10px',
                            fontSize: '13px'
                        },
                        '.MuiTableCell-head': {
                            backgroundColor: 'background.tablebg',
                            padding: '10px 8px',
                            borderBottom: '0px',
                            fontSize: '13px',
                            fontWeight: 'bold'
                        },
                    }}>
                        <TableContainer component={Paper} sx={{
                            overflow: { xs: 'auto', sm: 'hidden' },

                        }}>
                            <Table sx={{
                                minWidth: 450
                            }}
                                aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Sl.No</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Parent</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align="left">Category</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align="left">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    rows?.length !== 0 ?
                                        <TableBody>
                                            {rows?.map((row, ind) => (
                                                <TableRow
                                                    key={ind}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell align="left">{ind + 1}</TableCell>
                                                    <TableCell align="left">{row.parent}</TableCell>
                                                    <TableCell align="left">{row.label}</TableCell>
                                                    <TableCell align="right">
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-start'
                                                            }}
                                                        >
                                                            <IconButton disableRipple aria-label="delete" disabled={row.parent == null}
                                                                sx={{ margin: '0px 2px', padding: '5px', backgroundColor: '#fbc7c78c' }}
                                                                onClick={() => deleteGroup(row)}
                                                            >
                                                                <DeleteIcon sx={{ fontSize: '15px', color: row.parent == null ? "white" : '#eb6a6a' }} />
                                                            </IconButton>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        :
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align="center" colSpan={4}>No Category Found</TableCell>
                                            </TableRow>
                                        </TableBody>
                                }
                            </Table>
                        </TableContainer>

                    </Box> */}

          <Box
            sx={{
              // padding : "15px",
              // width:'100%',
              display: "flex",
              justifyContent: "space-between",
              // flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Button
              onClick={handleClose}
              disabled={loading}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleNewGroup}
              disabled={loading}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Add New Category
            </Button>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default ViewPartyGroups;
